module.exports = "query GetContact($id: ID!) {\n  contact(id: $id) {\n    ...DetailedContactFragment\n  }\n}\n"